function apiBaseUrl() {
  return process.env.REACT_APP_API_BASE_URL;
}

export function apiV2CreateUserPersonalTrustpassUrl(userId) {
  return `${apiBaseUrl()}/api/v2/users/${userId}/personal_trustpasses`;
}

export function apiV2UpdateUserPersonalTrustpassUrl(userId, personalTrustpassId) {
  return `${apiBaseUrl()}/api/v2/users/${userId}/personal_trustpasses/${personalTrustpassId}`;
}

export function apiV2FetchUserPersonalTrustpassesUrl(userId) {
  return `${apiBaseUrl()}/api/v2/users/${userId}/personal_trustpasses`;
}

export function apiV2FetchUserPersonalTrustpassUrl(userId, personalTrustpassId) {
  return `${apiBaseUrl()}/api/v2/users/${userId}/personal_trustpasses/${personalTrustpassId}`;
}

export function apiV2SubmitUserPersonalTrustpassUrl(userId, personalTrustpassId) {
  return `${apiBaseUrl()}/api/v2/users/${userId}/personal_trustpasses/` +
         `${personalTrustpassId}/submission`;
}



// WEBPACK FOOTER //
// ./src/features/trustpass/personalTrustpassApiUrls.js